import { FC, useState } from "react";
import styles from "./style.module.scss";

interface StateProps {
  text: string;
  onChange: (data: number) => void;
  onBlur: (e: React.FocusEvent<HTMLInputElement>) => void;
  name: string;
  min?: number;
  max?: number;
  value: number;
}

const NumberInputGroup: FC<StateProps> = ({
  text,
  onChange,
  min = 0,
  max = 1000000,
  value,
  onBlur,
}) => {
  const [inputValue, setInputValue] = useState<string>(
    value ? String(value) : "0"
  );

  const handleFocus = () => {
    if (inputValue === "0") setInputValue("");
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (inputValue === "" || inputValue === null) {
      setInputValue("0");
      onChange(0);
    } else {
      onChange(Number(inputValue));
    }
    onBlur(e);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    if (val.length > 1 && val.startsWith("0")) {
      return;
    }
    if (val === "0") {
      return;
    }
    if (val === "") {
      setInputValue("");
      onChange(0);
      return;
    }
    setInputValue(val);
    onChange(Number(val));
  };

  return (
    <div className={styles.slaInputGroup}>
      <div className={styles.slaBox}>
        <input
          className={styles.inputText}
          type="number"
          min={min}
          max={max}
          value={inputValue}
          onFocus={handleFocus}
          onBlur={handleBlur}
          onChange={handleChange}
        />
        <span className={styles.unit}>{text}</span>
      </div>
    </div>
  );
};

export default NumberInputGroup;
